import React from 'react';
import SpeakerCardList, { SpeakerContent } from './SpeakerCardList'; // Adjust import path
import PreviousSSD from '../../sanityInterfaces/PreviousSSD';

interface ContentProps {
  data: PreviousSSD;
}

const SpeakersContent = (props: ContentProps) => {
  // Transform SpeakerPage data to match SpeakerContent interface
  const speakerData: SpeakerContent[] = props?.data?.SpeakerPage?.map((item) => ({
    name: item.name,
    Role: item.Role,
    university: item.university,
    profileUrl: item.profileUrl,
    image: item.image,
    Biography: item.Biography || [],
    Abstract: item.Abstract || [],
    AbstractTitle: item.AbstractTitle || '',
  })) || [];

  return (
    <div className="p-4">
      <SpeakerCardList data={speakerData} />
    </div>
  );
};

export default SpeakersContent;